interface HeroSectionProps {
  onPlayRadio: () => void;
  isPlaying: boolean;
  onWhatsAppClick: () => void;
}

export default function HeroSection({ onPlayRadio, isPlaying, onWhatsAppClick }: HeroSectionProps) {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-purple-900 to-black">
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="w-full relative z-10">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-8 items-center min-h-screen py-16 max-w-5xl mx-auto">
            <div className="text-white text-center lg:text-left">
              <div className="flex justify-center lg:justify-start mb-6">
                <div className="relative">
                  <img 
                    alt="DJ Jean Logo" 
                    className="w-16 h-16 rounded-full object-cover shadow-2xl border-4 border-white/30" 
                    src="https://static.readdy.ai/image/0179d60eb192a4383e7134d41ff99ed6/7d0c5962630ec0c61617194cca58b51e.jfif"
                  />
                </div>
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">DJ Jean</h1>
              <h2 className="text-lg md:text-2xl lg:text-3xl font-light mb-6">Som e Iluminação Profissional para seu Evento!</h2>
              <p className="text-base md:text-lg mb-8 max-w-2xl leading-relaxed text-gray-200 mx-auto lg:mx-0">
                Atendemos casamentos, aniversários, debutantes, festas e eventos em geral com estrutura completa de som, luz e efeitos especiais.
              </p>
              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4 mb-6">
                <button 
                  onClick={onPlayRadio}
                  className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-6 py-3 rounded-full text-base font-bold transition-all transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap flex items-center justify-center"
                >
                  <i className={`${isPlaying ? 'ri-pause-circle-line' : 'ri-play-circle-line'} mr-2 text-lg`}></i>
                  {isPlaying ? 'Pausar Rádio DJ Jean' : 'Tocar Rádio DJ Jean'}
                </button>
                <button 
                  onClick={onWhatsAppClick}
                  className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-full text-base font-bold transition-all transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap flex items-center justify-center"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Falar com DJ Jean
                </button>
              </div>
            </div>
            
            <div className="flex justify-center lg:justify-end">
              <div className="relative max-w-md w-full">
                <img 
                  alt="DJ Jean em ação" 
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover" 
                  src="https://static.readdy.ai/image/0179d60eb192a4383e7134d41ff99ed6/685179fd98b212c02dd7c48f5d5f75ac.jfif"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/30 to-transparent rounded-2xl"></div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full animate-pulse"></div>
                <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full animate-pulse delay-1000"></div>
                <div className="absolute top-1/2 -left-6 w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full animate-pulse delay-500"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>
    </section>
  );
}